var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.999,
    cy: 5.584,
    rx: 5.588,
    ry: 5.585,
    fill: "#F7D000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.72 9.799a6.952 6.952 0 01-4.788 2.636L10.517 16l1.695-2.89 3.202.498-1.695-3.81zm-6.016 2.65a6.953 6.953 0 01-5.11-2.861L.587 13.642l3.524-.526 1.838 2.878 1.756-3.544z",
    fill: "#F7AB00"
  })));
}
export default SvgPr;